import {
  clearRazorPayTransferOrder,
  completeRazorPayTransferOrder,
  razorPayTransferOrder,
} from "common/features/payment/PaymentActions";
import { RootState } from "common/rootReducer";
import {
  getPaymentStatusURL,
  getOrderTrackingURL,
  getContactlessDineinLandingPage,
  getContactlessDineInOrderStatusURL,
  getContactlessDineinRatingURL,
} from "common/utils/route-util";
import { clearMenuDetails } from "common/features/restaurant/restaurantAction";
import { clearOrderDetails } from "common/features/order/orderActions";
import { getUserGivenDetails } from "common/features/user/userActions";
import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useMemo,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  clearPlaceOrder,
  clearRunningCart,
} from "common/features/cart/cartActions";
import { AuthContext } from "common/services/auth-service";
import { OrderType } from "common/features/restaurant/restaurantModels";
import { clearGetOrderDetail } from "common/features/order/orderActions";

export const useRazorPay = (
  openPayment: boolean,
  tableId?: string
): [(totalOrderPrice: number) => void, () => void, boolean] => {
  const history = useHistory();
  const dispatch = useDispatch();
  const AppAuth = useContext(AuthContext);

  const userName = useSelector(
    (state: RootState) => state.auth.guestUser?.fullName
  );

  const signedIn = AppAuth?.userState == "signedIn";

  const loggedInUserName = useSelector(
    (state: RootState) => state.user.currentUserDetail.userName
  );

  const loggedInUserMobile = useSelector(
    (state: RootState) => state.user.currentUserDetail.phoneNumber
  );

  const loggedInUserEmail = useSelector(
    (state: RootState) => state.user.currentUserDetail.email
  );

  const currentRestaurantDetail = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const mobile = useSelector(
    (state: RootState) => state.auth.guestUser?.mobile
  );
  const email = useSelector((state: RootState) => state.auth.guestUser?.email);

  const payment = useSelector((state: RootState) => state.payment);

  const [paymentOpened, setPaymentOpened] = useState<boolean>(false);

  const cartRestaurantSlug = useSelector(
    (state: RootState) => state.cart.cartRestaurantSlug
  );
  const cartMerchantType = useSelector(
    (state: RootState) => state.cart.merchantType
  );
  const locationId = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.id
  );
  const orderDetail = useSelector(
    (state: RootState) => state.order.currentOrderDetail
  );

  const cartOrderId = useSelector((state: RootState) => state.cart.orderId);
  const userID = localStorage.getItem("USER_ID");

  useEffect(() => {
    userID && signedIn && dispatch(getUserGivenDetails());
  }, []);

  useEffect(() => {
    // console.log("Opened:", paymentOpened);

    if (!payment.razorPayTransferOrderLoading) {
      if (payment.razorPayTransferOrderSuccess) {
        // console.log(payment);
        if (
          payment.razorPayTransferredOrderDetails &&
          payment.razorPayTransferredOrderDetails.paymentTransactionTokenId &&
          !paymentOpened &&
          openPayment
        ) {
          // console.log("DIsplay Pay");

          setPaymentOpened(true);
          dispatch(completeRazorPayTransferOrder());

          openPayment &&
            !paymentOpened &&
            displayRazorpay(
              0,
              payment.razorPayTransferredOrderDetails
                ?.paymentTransactionTokenId,
              payment.razorPayTransferredOrderDetails?.paymentAmount
            );
        }
      }
    }
  }, [payment.razorPayTransferOrderSuccess]);

  function loadScript(src: string) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );
  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );

  const orderDetails = useSelector(
    (state: RootState) => state.order.currentOrderDetail
  );

  const isContactlessDineInOrder = useMemo(() => {
    return (
      window.location.pathname.includes("table") &&
      (currentRestaurantDetail.dining == 2 ||
        currentRestaurantDetail.dining == 3)
    );
  }, [currentRestaurantDetail]);

  const goToPaymentStatusPage = () => {
    if (isContactlessDineInOrder && currentRestaurantDetail && orderDetails) {
      history.push(
        getContactlessDineInOrderStatusURL(
          "restaurant",
          currentRestaurantDetail.locationSlug || "",
          tableId || "",
          orderDetails.orderId
        )
      );
    } else {
      history.push(
        getPaymentStatusURL(cartMerchantType, cartRestaurantSlug, cartOrderId)
      );
    }
  };

  const restaurantCurrentMenuType = useSelector(
    (state: RootState) => state.restaurant.restaurantCurrentMenuType
  );

  const dineInOrderTypeId = useMemo(() => {
    if (currentRestaurantDetail.orderTypes) {
      return (
        currentRestaurantDetail.orderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "D"
        )?.id || ""
      );
    }
    return "";
  }, [currentRestaurantDetail]);
  async function displayRazorpay(
    donateamount: number,
    orderId: string,
    amount: number
  ) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZOR_PAY_KEY,
      currency: "INR",
      amount: Math.round(amount) * 100,
      order_id: orderId,
      name: "MAGILHUB",
      description: "",
      image:
        "https://media-exp1.licdn.com/dms/image/C4D0BAQFF-OYCp5oCgw/company-logo_200_200/0?e=2159024400&v=beta&t=sjx4XfEXEMLFgAT2Xb-3qaPnNksj_sWFdN7pZtm9G-k",
      handler: function (response: any) {
        // console.log(response);
        if (response.razorpay_payment_id) {
          //dispatch(clearPlaceOrder());
          dispatch(clearRazorPayTransferOrder());
          if (cartMerchantType == "restaurant") {
            if (isContactlessDineInOrder && orderDetails) {
              dispatch(clearMenuDetails());

              history.push(
                getContactlessDineinRatingURL(
                  "restaurant",
                  currentRestaurantDetail.locationSlug,
                  tableId || "",
                  orderDetails.orderId
                )
              );
              dispatch(clearOrderDetails());
            } else {
              history.replace(
                getOrderTrackingURL(cartRestaurantSlug, cartOrderId)
              );
            }
          } else {
            if (isContactlessDineInOrder && orderDetails) {
              dispatch(clearGetOrderDetail());
              dispatch(clearRunningCart());
              history.push(
                getContactlessDineinRatingURL(
                  "restaurant",
                  currentRestaurantDetail.locationSlug,
                  tableId || "",
                  orderDetails.orderId
                )
              );
            } else {
              goToPaymentStatusPage();
            }
          }
        } else {
          alert("Error while processing the payment");
          goToPaymentStatusPage();
        }
      },
      modal: {
        ondismiss: function () {
          console.log("Dismiss");
          goToPaymentStatusPage();
        },
      },
      prefill: {
        // Current Users Details from Redux
        name: signedIn ? loggedInUserName : userName,
        email: signedIn ? loggedInUserEmail : email,
        contact: signedIn ? loggedInUserMobile : mobile,
      },
      theme: {
        color: "#67833e",
      },
    };

    const paymentObject = new (window as any).Razorpay(options);
    paymentObject.open();
  }
  const payViaRazorPay = useCallback(
    (totalOrderPrice: number) => {
      dispatch(
        razorPayTransferOrder({
          totalPaymentAmount: Math.ceil(totalOrderPrice).toString(),
          paymentCurrency: "INR",
          locationId: locationId,
          orderId: isContactlessDineInOrder
            ? orderDetail?.orderId || ""
            : cartOrderId,
          // Hardcoded for now, Change it for future use
          tenderType: "CNP",
          isToValidateRecaptchaToken:false
        })
      );
    },
    [cartOrderId, locationId, orderDetail]
  );

  const retryPaymentViaRazorPay = useCallback(() => {
    // console.log("Retry");
    if (
      payment.razorPayTransferredOrderDetails &&
      payment.razorPayTransferredOrderDetails.paymentTransactionTokenId
    ) {
      displayRazorpay(
        0,
        payment.razorPayTransferredOrderDetails?.paymentTransactionTokenId,
        payment.razorPayTransferredOrderDetails?.paymentAmount
      );
    }
  }, [payment]);

  return [
    payViaRazorPay,
    retryPaymentViaRazorPay,
    payment.razorPayTransferOrderLoading,
  ];
};
